// extracted by mini-css-extract-plugin
export default {"nav":"XVPL8q","icon":"_3sKSe","withCount":"_SWmiG","badge":"NUcgT6"};